import React, { useEffect, useRef, useState } from "react";
import TextField from "../../UI/Inputs/TextField";
import Button from "../../UI/Buttons/Button";
import showToast from "../../../Helpers/toast";
import useApi from "../../../Hooks/useApi";
import {
  addQuestionnaireTitle,
  copyFromTemplate,
  updateQuestionnaireTitle,
} from "../../../Utils/questionnaireUtils";

const QuestionnaireTitle = ({ questionnaireMeta, setQuestionnaireMeta }) => {
  const isTemplate = questionnaireMeta?.isTemplate;
  const [title, setTitle] = useState(questionnaireMeta?.name);
  const [disabled, setDisabled] = useState(false);
  const [editMode, setEditMode] = useState(!!questionnaireMeta?.name);
  const { request } = useApi();
  const formRef = useRef(null);

  useEffect(() => {
    if (editMode) {
      setDisabled(true);
    }
  }, []);

  useEffect(() => {
    if (questionnaireMeta?.id) {
      setEditMode(true);                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
    }
  }, [questionnaireMeta?.id]);

  useEffect(() => {
    if (questionnaireMeta && questionnaireMeta.name) {
      setEditMode(true);
      setTitle(questionnaireMeta.name);
    }
  }, [questionnaireMeta]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (title && title.trim().length) {
      if (!isTemplate) {
        try {
          const response = !editMode
            ? await addQuestionnaireTitle(request, {
                title: title,
              })
            : await updateQuestionnaireTitle(request, {
                id: questionnaireMeta?.id,
                title: title,
              });
          setQuestionnaireMeta(response);
          setDisabled(true);
        } catch (error) {
          console.log(error);
          showToast({
            message: error?.response?.data?.message || "Error Occurred",
            type: "error",
          });
        }
      }
    } else {
      showToast({ message: "Title can't be empty!", type: "error" });
    }
  };

  const handleTemplateCopy = async () => {
    try {
      const newTitle = `${title}-${+new Date()}`;
      const response = await copyFromTemplate(request, {
        questionnaireId: questionnaireMeta?.id,
        name: newTitle,
      });
      setQuestionnaireMeta({ ...response, isTemplate: false });
      setTitle(newTitle);
      setDisabled(true);
      showToast({
        message: "Template Copied Successfully!",
      });
    } catch (error) {
      setQuestionnaireMeta({...questionnaireMeta, isTemplate: false });
      showToast({
        message: error?.response?.data?.message || "Error Occurred",
        type: "error",
      });
    }
  };

  useEffect(() => {
    if (isTemplate) {
      handleTemplateCopy();
    }
  }, []);

  return (
    <div>
      <form
        ref={formRef}
        onSubmit={handleSubmit}
        className="flex gap-4 pb-4 items-end"
      >
        <TextField
          disabled={disabled}
          name="title"
          label={`${isTemplate ? "New " : ""}Questionnaire Title`}
          placeholder={"Write Questionnaire Title"}
          style={{
            borderRadius: "5px",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          }}
          value={title}
          onValueChange={(_, val) => setTitle(val)}
          required={true}
          icon={
            editMode &&
            disabled && (
              <i
                onClick={() => {
                  setDisabled(false);
                }}
                className="fas fa-edit cursor-pointer"
              ></i>
            )
          }
          iconPosition={"right"}
        />

        {!disabled ? (
          <Button
            type={"small_bordered"}
            label={editMode ? "Update" : "Submit"}
            backgroundColor={"#2F4B7C"}
            textColor={"white"}
            style={{
              height: "40px",
              width: "100px",
            }}
          />
        ) : (
          <></>
        )}
      </form>
      {!questionnaireMeta && (
        <p className="p-10 text-gray-700 text-center italic bg-gray-100 rounded-md">
          + Add a Title to Your Questionnaire Before Adding Questions
        </p>
      )}
    </div>
  );
};

export default QuestionnaireTitle;

